module.exports = __webpack_public_path__ + "public/SiteImages/star.svg?cf4a2a63";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/star.svg
// module id = 645
// module chunks = 8